import React,{useEffect,useState,useRef} from 'react';
import axios from 'axios'
import swal from 'sweetalert';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import * as Yup from 'yup';
import { getIp } from '../../utils/common';

const publicIp = require('public-ip');

const initialValues = {
	otp_code: '',
};

const validationSchema = Yup.object({
	otp_code: Yup.string().required('OTP is required'),
});


const TotpOtp = (props) => {

	const [isActive, setIsActive] = useState(true);
	const [seconds, setSeconds] = useState(30);
	const [showQR,setShowQR]=useState(true)
	const [showPass, setShowPass] = useState(false);
	const [QRText,setQrText]=useState('')
	const { clientID } = props;
	const [showtimer,setShowtimer]=useState(false)
	const [qrResponse,setQrResponse]=useState({})
	const [showloader, setshowloader] = useState(false);
	const [key,setKey]=useState('')
	const defaultHeaders = {
		'Content-Type': 'application/json',
		'Accept': 'application/json',
		'X-UserType': 'USER',
		'X-SourceID': 'WEB',
		'X-ClientLocalIP': publicIp.v4(),
		'X-ClientPublicIP': getIp(),
		'X-MACAddress': '',
		// 'X-PrivateKey': ''
	};
	
	const queryExt = (value) => {
		var url = value;
		var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
		// console.log('STring::::', queryString);
		const parse = new URLSearchParams(queryString);
		const params = parse.get('secret');
		setKey(params);
		return params;
	};

    const Ref = useRef(null);
  
    const [timer, setTimer] = useState('00');
  
  
    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        
        return {
            total, seconds
        };
    }
  
  
    const startTimer = (e) => {
        let { total, seconds } 
                    = getTimeRemaining(e);
        if (total >= 0) {
  
            // update the timer
            // check if less than 10 then we need to 
            // add '0' at the beginning of the variable
            setTimer(
                // (hours > 9 ? hours : '0' + hours) + ':' +
                // (minutes > 9 ? minutes : '0' + minutes) + ':'
                 (seconds > 9 ? seconds : '0' + seconds)
            )
        }
    }
  
  
    const clearTimer = (e) => {
  
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }
  
    const getDeadTime = () => {
        let deadline = new Date();
  
        deadline.setSeconds(deadline.getSeconds() + 30);
        return deadline;
    }
  

    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);
  

    const onClickReset = () => {
        clearTimer(getDeadTime());
    }
	



	const resendOtp= async()=>{
		const response = await axios({
			method: 'post',
			url: 'https://apiconnect.angelone.in/rest/auth/angelbroking/user/v1/totp/otp/generate',
			headers: defaultHeaders,
			data: {
				clientcode: clientID,
			},
		})
			.then((response) => {
				console.log('OTP Generate:::', response);
				response.data.status
					? swal({
							text: 'OTP Resend',
							icon: 'success',
							dangerMode: true,
					  })
					: swal({
							text: response.data.message,
							icon: 'warning',
							dangerMode: true,
					  });
			})
			.catch((error) => {
				swal({
					text: error,
					icon: 'warning',
					dangerMode: true,
				});
			});
	}

	const proceed= async()=>{
		setshowloader(true);
		const otp = document.getElementById('otp-code').value;
		console.log(clientID);
		// generateQR("otpauth://totp/B210992?secret=Y2PWAJUB5OFWOSS7EQ3XOYKBBY&issuer=angelone.com&algorithm=SHA1&digits=6&period=30");
		const response = await axios({
			method: 'post',
			url: 'https://apiconnect.angelone.in/rest/auth/angelbroking/user/v1/totp/otp/verify',
			headers: defaultHeaders,
			data: {
				clientcode: clientID,
				otp: otp,
			},
		})
			.then((response) => {
				// var Response=setQrResponse(response)
				if(response.data.status){
					setQrResponse(response);
					setshowloader(false);
					setShowQR(false);
                    queryExt(response.data.data.uri);

				}
				else{
					swal({
						text: response.data.message,
						icon: 'warning',
						dangerMode: true,
					});
				}
					// console.log('::ResponseQr', response);
			})
			.catch(function (error) {
				setshowloader(false);
				// console.log(error);
				swal({
					text: error,
					icon: 'warning',
					dangerMode: true,
				});
			});
	}

	

    return (
			<div className="containerOTP">
				<div className="OTP">
					{showQR ? (
						<div>
							<div className="OTP_Text">
								<span>
									<h3>Enter OTP send to Registered Email and Mobile</h3>
								</span>
							</div>
							<Formik
								initialValues={initialValues}
								validationSchema={validationSchema}
								onSubmit={proceed}
							>
								<Form>
									<div>
										<div class="row flex-row bgWhite ">
											<div class="col-1 verticalCenter">
												<i class="fa fas fa-keyboard"></i>
											</div>
											<div class="col-10 verticalCenter centerTextPass ">
												<label>
													<Field
														type={showPass ? 'text' : 'password'}
														className="borderNone"
														id="otp-code"
														name="otp_code"
														placeholder="OTP"
													/>
													<div className="errorText">
														<ErrorMessage name="otp_code" />
													</div>
												</label>

												<div>
													<text id="emailerr" class="err"></text>
												</div>
											</div>
											<div className="col-1 verticalCenter">
												<span
													onClick={() => {
														setShowPass(!showPass);
													}}
													toggle="#password-field"
													class="fa fa-fw fa-eye field_icon toggle-password icon-eye"
												></span>
											</div>
										</div>
										{/* <div className="errorText">
											<ErrorMessage name="otp_code" />
										</div> */}
										<div className="resendOtp">
											{timer== 0 ? (
												<div>
													<button
														onClick={() => {
															resendOtp();
															onClickReset();
															// setShowtimer(true);
															// setIsActive(true);
														}}
														className="resend"
														// disabled={seconds !== 0 ? true : false}
													>
														Resend OTP
													</button>
												</div>
											) : (
												<div>00:{timer}</div>
											)}
											{/* <div>
												<button
													onClick={() => {
														resendOtp();
														setShowtimer(true);
														setIsActive(true);
													}}
													className="resend"
													// disabled={seconds !== 0 ? true : false}
												>
													Resend OTP
												</button>
											</div> */}
										</div>
										<div className="loginDiv">
											<button
												type="submit"
												className="loginbtn"
												onClick={() => {
													// proceed();
												}}
											>
												Proceed
											</button>
										</div>
									</div>
								</Form>
							</Formik>
							{/* <button
							onClick={() => {
								setIsActive(true);
							}}
						>
							Resend
						</button> */}
							{/* <div className=" resent">
								<h3>Resend OTP in 00: {seconds} seconds</h3>
							</div> */}
						</div>
					) : (
						<div className="QRScan">
							<div>
								{showloader === false ? (
									<img
										src={qrResponse.data.data.imageUri}
										// src="data:image/png;base64,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"
										alt="N/A"
									/>
								) : (
									<div class="spinner-border" role="status">
										<span class="sr-only">Loading...</span>
									</div>
								)}
							</div>
							<div>
								<p className="keyText">Can't Scan ? Copy the key</p>
								{showloader === false ? (
									<p>{key}</p>
								) : (
									<div class="spinner-border" role="status">
										<span class="sr-only">Loading...</span>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
			</div>
		);
};

export default TotpOtp;